import { useEffect } from "react";
import { setImpersonationToken } from "@/lib/api";

// Landing route for "Open workspace". Reads the read-only token from the URL hash,
// stores it in this tab's sessionStorage (never localStorage), then enters /app.
export default function ImpersonationEntry() {
  useEffect(() => {
    const h = window.location.hash || "";
    const m = h.match(/t=([^&]+)/);
    if (m) setImpersonationToken(decodeURIComponent(m[1]));
    window.location.replace("/app");
  }, []);
  return null;
}
